<template>
  <div class="container placeholders placeholder-glow">
    <div v-for="(row, index) in list"
         :key="index"
         class="row mt-1"
         :class="{'gx-0': row.length === 1}"
    >
      <div v-for="(col, colIndex) in row"
           :key="`${index}-${colIndex}`"
           class="mb-1"
           :class="`col-${col}`"
      >
        <div class="w-100 placeholder" />
      </div>
    </div>
  </div>
</template>
<script setup>
import {reactive} from "vue";

const props = defineProps({
  placeholders: Array,
});
const list = reactive(props.placeholders || [[12], [8], [6], [10]]);
</script>